import moment from "moment-timezone";
import { useCallback, useMemo } from "react";
import { Button, Stack } from "react-bootstrap";
import Datetime from "react-datetime";
import { X } from "react-feather";

const DateFilter = (props) => {
  const {
    column: { filterValue, setFilter },
  } = props;

  const filterPrefix = "$DATE=";
  const filterBefore = "<";
  const filterAfter = ">";

  const parseFilterValue = useCallback(() => {
    var parseResult = { dateSelected: null, beforeAfter: false };

    if (
      filterValue &&
      typeof filterValue === "string" &&
      filterValue.startsWith(filterPrefix)
    ) {
      var dateStartPos = filterPrefix.length;
      if (
        filterValue.substring(
          filterPrefix.length,
          filterPrefix.length + filterBefore.length
        ) === filterBefore
      ) {
        parseResult.beforeAfter = false;
        dateStartPos += filterBefore.length;
      } else if (
        filterValue.substring(
          filterPrefix.length,
          filterPrefix.length + filterAfter.length
        ) === filterAfter
      ) {
        parseResult.beforeAfter = true;
        dateStartPos += filterAfter.length;
      }

      var dateString = filterValue.substring(dateStartPos);
      var momentDate = moment(dateString);

      parseResult.dateSelected = momentDate;
    }

    return parseResult;
  }, [filterValue]);

  const { dateSelected, beforeAfter } = useMemo(
    () => parseFilterValue(),
    [parseFilterValue]
  );

  const updateFilter = useCallback(
    ({
      dateSelected: newDateSelected = undefined,
      beforeAfter: newBeforeAfter = undefined,
    }) => {
      if (
        typeof newDateSelected === "undefined" &&
        typeof newBeforeAfter === "undefined"
      ) {
        setFilter("");
        return;
      }

      var filterValues = {
        dateSelected:
          typeof newDateSelected !== "undefined"
            ? newDateSelected
            : dateSelected,
        beforeAfter:
          typeof newBeforeAfter !== "undefined" ? newBeforeAfter : beforeAfter,
      };

      if (moment.isMoment(filterValues.dateSelected)) {
        var filter =
          filterPrefix +
          (filterValues.beforeAfter ? filterAfter : filterBefore);
        filter +=
          filterValues && filterValues.dateSelected._isValid
            ? filterValues.dateSelected.toISOString()
            : "";
        setFilter(filter);
      } else {
        setFilter("");
      }
    },
    [dateSelected, beforeAfter]
  );

  const renderInput = (props, openCalendar, closeCalendar) => {
    function clear() {
      closeCalendar();
      props.onChange({ target: { value: "" } });
      updateFilter({});
    }
    return (
      <div className="d-flex justify-content-between align-items-center">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            updateFilter({ beforeAfter: !beforeAfter });
          }}
        >
          {!beforeAfter ? "before" : "after"}
        </span>
        &nbsp;
        <input {...props} style={{ minWidth: "110px", maxWidth: "110px" }} />
        <Button variant="" className="p-0 m-0" onClick={clear}>
          <X />
        </Button>
      </div>
    );
  };

  const renderView = (mode, renderDefault) => {
    if (mode === "time") return renderDefault();

    return (
      <Stack>
        {renderDefault()}
        <div className="d-flex justify-content-between align-items-center">
          <button
            onClick={() => {
              updateFilter({ beforeAfter: false });
            }}
          >
            Before
          </button>
          <button
            onClick={() => {
              updateFilter({ beforeAfter: true });
            }}
          >
            After
          </button>
        </div>
      </Stack>
    );
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <Datetime
        value={dateSelected}
        onChange={(v) => {
          if (moment.isMoment(v)) {
            updateFilter({ dateSelected: v });
          }
        }}
        renderInput={renderInput}
        renderView={renderView}
        dateFormat="DD/MM/YYYY"
        timeFormat={false}
        locale="en-gb"
        utc={true}
        isValidDate={(a, b) => {
          return a < new Date();
        }}
      />
    </div>
  );
};

export default DateFilter;
